export const APOLLO_MESSAGES = {
  errors: {
    default: 'Something went wrong, please try again',
    network: 'Please check your internet connection and try again',
    unauthorized: 'You need to be logged in to perform this action',
    forbidden: 'You don\'t have permission to perform this action'
  }
} as const; 